<template>
  <div>
  	<div class="input-group">
      <div class="input-group-addon"><span>{{ title }}</span></div>
      <div class="autocomplete-wrapper">
        <input type="text" class="form-control" :placeholder="title" 
          v-model="selectedValue"
          @keyup="loadOptions"
          @blur="hideResults(0)" >
        <ul v-if="terms && showAutocompleteResults" class="autocomplete-results">
          <li v-for=" (term, index) in terms" @click="setAutocompleteValue(term)" :key="index">{{ term }}</li>
        </ul>
      </div> 
    </div>
<!-- <pre>{{ reset }}</pre> -->
  </div>
</template>

<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex';

	export default {
    props: ['title', 'searchField', 'searchCategory', 'value', 'reset'],
    data: () => {
      return{
        initialized: false,
        loading: false,
        options: [],
        selectedValue: '',
        showAutocompleteResults: true,
        terms: [],
        timeout: null,
      }
    },
    created(){
    	this.loadOptions();
    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl', 'getCategory']), 
  	},
  	methods: {
  		loadOptions(){
        if(this.selectedValue.length>=1){

          let infantil = (this.getCategory == 'infantil') ? '&infantil=true' : '';
          //let category = (this.getCategory == 'infantil') ? this.searchCategory : this.getCategory

          let category = this.searchCategory

          /* let category = ''
          if(this.getCategory == 'infantil'){
            if( this.searchCategory == 'todos' ){
              category = 'cine'
            }else{
              category = this.searchCategory
            }            
          }else{
            category = this.getCategory
          } */


          clearTimeout(this.timeout);
          this.timeout = setTimeout(function() {
            axios.get(this.getApiUrl + this.getLocale + '/' + category + '/autocomplete?campo=' + this.searchField + '&busqueda=' + encodeURI(this.selectedValue) + infantil)
          .then( (respuesta) =>{
            this.terms = respuesta.data.data;
            this.showAutocompleteResults = true;
          })
          .catch( (error) =>{ 
            this.terms = [];
          });
          }.bind(this), 300);
        }  
  		},
      setAutocompleteValue(term){
        this.selectedValue = term;
        this.showAutocompleteResults = false;
      },
      hideResults(tmp){
        if(tmp){
          this.showAutocompleteResults = false;
        }else{
          setTimeout(() => {
            this.showAutocompleteResults = false;
          }, 300);
        }
      }
  	},
  	watch:{
  		selectedValue: function(){
  			this.$emit('update:value', this.selectedValue);
  		},
      reset: function(){
        
          //alert('child: resetValue')
          this.selectedValue = '';
          this.$emit('update:value', this.selectedValue);
          //alert('child: emit update value')
          //this.$emit('update:reset', false);
          //alert('child: emit update reset')
       
      }
  	}
  }
</script>
